import common from './common.json';
import home from './home.json';
import login from './login.json';

export default { common, home, login };
